const Mutations = Object.freeze({
	SET_REPORTS:
		'reportBuilderModule/reportBuilder/workbookDetails/SET_REPORTS',
	SET_WORKBOOK:
		'reportBuilderModule/reportBuilder/workbookDetails/SET_WORKBOOK',
});

export const Actions = Object.freeze({
	LOAD_DATA: 'reportBuilderModule/reportBuilder/workbookDetails/LOAD_DATA',
	SAVE: 'reportBuilderModule/reportBuilder/workbookDetails/SAVE',

	ADD_WORKBOOK_REPORTS:
		'reportBuilderModule/reportBuilder/workbookDetails/ADD_WORKBOOK_REPORTS',
	CLEAR: 'reportBuilderModule/reportBuilder/workbookDetails/CLEAR',
});

export const Getters = Object.freeze({
	REPORTS: 'reportBuilderModule/reportBuilder/workbookDetails/REPORTS',
	WORKBOOK: 'reportBuilderModule/reportBuilder/workbookDetails/WORKBOOK',
	WORKBOOK_REPORTS:
		'reportBuilderModule/reportBuilder/workbookDetails/WORKBOOK_REPORTS',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/reportBuilderService';

export default {
	state: {
		reports: [],
		workbook: null,
	},
	mutations: {
		[Mutations.SET_REPORTS](state, items) {
			state.reports = items;
		},
		[Mutations.ADD_WORKBOOK_REPORTS](state, item) {
			let w = JSON.parse(JSON.stringify(state.workbook));
			w.WorkbookReports.push(item);
			state.workbook = w;
		},
		[Mutations.SET_WORKBOOK](state, item) {
			state.workbook = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_REPORTS, []);
				commit(Mutations.SET_WORKBOOK, null);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},

		[Actions.LOAD_DATA]({ commit, dispatch }, workbookId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, false);
				Promise.all([
					dataService.getReports().then((resp) => {
						commit(Mutations.SET_REPORTS, resp.data);
					}),
					dataService.getWorkbook(workbookId).then((resp) => {
						commit(Mutations.SET_WORKBOOK, resp.data);
					}),
				])
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.SAVE]({ dispatch, commit }, workbook) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				if (workbook.Id) {
					dataService
						.updateWorkbook(workbook)
						.then(() => {
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					dataService
						.addWorkbook(workbook)
						.then((resp) => {
							commit(Mutations.SET_WORKBOOK, resp.data);
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
				dispatch(GeneralActions.LOADING, false);
				resolve(true);
			});
		},
	},
	getters: {
		[Getters.REPORTS]: (state) => {
			if (!state.reports) return [];
			if (state.reports.length <= 0) return [];
			return state.reports;
		},
		[Getters.WORKBOOK]: (state) => {
			if (!state.workbook) return null;
			return JSON.parse(JSON.stringify(state.workbook));
		},
		[Getters.WORKBOOK_REPORTS]: (state) => {
			if (!state.workbook.WorkbookReports) return [];
			if (state.workbook.WorkbookReports.length <= 0) return [];
			return JSON.parse(
				JSON.stringify(
					JSON.parse(
						JSON.stringify(state.workbook.WorkbookReports)
					).sort((a, b) => (a.Order > b.Order ? 1 : -1))
				)
			);
		},
	},
};
